<div class="container">
    <mat-dialog-title class="title-block">
        <h3>Map: "{{unrecognizedEpisodeName}}"</h3>
        <app-close-x-icon (click)="onClose()"></app-close-x-icon>
    </mat-dialog-title>

    <div class="show-container">
        <div class="show-block">
            <span id="show-label">SHOW:</span>

            <span id="show-name">
                {{show.name}}
            </span>
        </div>
    </div>

    <mat-dialog-content class="content-block">

        <div class="radio-btns">
            <mat-radio-group aria-label="Seasons" [(ngModel)]="seasonSelectType">
                <mat-radio-button value="select-season">Select from existing seasons</mat-radio-button>
                <mat-radio-button value="create-season">Add new season</mat-radio-button>
            </mat-radio-group>
        </div>

        <div class="season-block">
            <div *ngIf="seasonSelectType == 'select-season'">
                <mat-select class="season-selector" [(ngModel)]="selectedSeason">
                    <mat-option *ngFor="let season of show.seasons" [value]="season">
                        {{season.name}}
                    </mat-option>
                </mat-select>
            </div>


            <div class="radio-btns" *ngIf="selectedSeason && seasonSelectType == 'select-season'">
                <mat-radio-group aria-label="Seasons" [(ngModel)]="episodeSelectType">
                    <mat-radio-button value="select-episode" [disabled]="checkForEpisodes(selectedSeason)">Select from existing episodes</mat-radio-button>
                    <mat-radio-button value="create-episode">Add new episode</mat-radio-button>
                </mat-radio-group>
            </div>

            <div *ngIf="selectedSeason && selectedSeason.episodes.length > 0 && episodeSelectType == 'select-episode' && seasonSelectType == 'select-season'">
                <mat-select class="episode-selector" [(ngModel)]="mapToEpisode">
                    <mat-option *ngFor="let episode of selectedSeason.episodes" [value]="episode">
                        {{episode.name}}
                    </mat-option>
                </mat-select>
            </div>

            <div *ngIf="seasonSelectType == 'create-season'">
                <mat-form-field class="create-season-name-field">
                    <mat-label class="create-season-name-label">Add New Season</mat-label>
                    <input matInput [(ngModel)]="newSeasonName">
                </mat-form-field>
                <mat-form-field class="create-season-num-field">
                    <mat-label class="create-season-num-label">Season #</mat-label>
                    <input matInput type="number" [(ngModel)]="newSeasonNumber">
                </mat-form-field>
            </div>

            <div *ngIf="selectedSeason && episodeSelectType == 'create-episode' || seasonSelectType == 'create-season'">
                <mat-form-field class="create-episode-name-field">
                    <mat-label class="create-episode-name-label">Add New Episode</mat-label>
                    <input matInput [(ngModel)]="newEpisodeName">
                </mat-form-field>
                <mat-form-field class="create-episode-num-field">
                    <mat-label class="create-episode-num-label">Episode #</mat-label>
                    <input matInput type="number" [(ngModel)]="newEpisodeNumber">
                </mat-form-field>
            </div>
           
        </div>


    </mat-dialog-content>

    <mat-dialog-actions class="action-block">
        <button class="map-episode-btn" mat-button (click)="mapEpisode()">MAP EPISODE</button>
        <button class="cancel-btn" mat-button (click)="onClose()">CANCEL</button>
    </mat-dialog-actions>
</div>